import { LatLngTuple } from 'leaflet';

export class MeteoInterval {
    constructor(public color: string, public latlngSequence: LatLngTuple[]) {
    }
}
